import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Package } from "lucide-react";
import { API } from "@/App";
import axios from "axios";

const fmtBRL = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export function MaterialConsumidoCard({ contratoId }) {
  const [dados, setDados] = useState(null);
  useEffect(() => {
    if (!contratoId) return;
    axios.get(`${API}/estoque-relatorios/custo-por-obra/${contratoId}`)
      .then((r) => setDados(r.data))
      .catch(() => setDados({ total: 0, movimentacoes: 0, materiais: [] }));
  }, [contratoId]);

  return (
    <Card className="border-0 shadow-sm" data-testid="material-consumido-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2 text-luvcorp-navy">
          <Package className="h-4 w-4 text-luvcorp-gold" />
          Material do Estoque
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {!dados ? (
          <p className="text-xs text-slate-400">Carregando…</p>
        ) : dados.movimentacoes === 0 ? (
          <p className="text-xs text-slate-400">Nenhuma saída de material registrada para esta obra.</p>
        ) : (
          <>
            <div className="flex justify-between items-center p-2.5 rounded-lg bg-amber-50 border border-amber-200">
              <span className="text-xs text-amber-800">
                {dados.movimentacoes} saída(s)
                {dados.ultima_saida && ` · última em ${dados.ultima_saida.split("-").reverse().join("/")}`}
              </span>
              <span className="font-bold text-amber-800" data-testid="material-consumido-total">{fmtBRL(dados.total)}</span>
            </div>
            <div className="space-y-1.5">
              {(dados.materiais || []).map((m, i) => (
                <div key={i} className="flex justify-between text-xs gap-2">
                  <span className="text-slate-600 truncate">
                    {m.nome} <span className="text-slate-400">({Number(m.quantidade).toLocaleString("pt-BR")})</span>
                  </span>
                  <span className="text-slate-700 font-mono shrink-0">{fmtBRL(m.valor)}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
